import { LookerIntegration } from 'api/APITypes';
import Button from 'components/inputs/basic/Button/Button';
import IconButton from 'components/inputs/basic/Button/IconButton';

interface YouAreAlreadyUsingLookerProps {
  lookerIntegration: LookerIntegration;
  handleShowSnowflakeInLookerClick: () => void;
  databaseDisplayName: string;
}

const YouAreAlreadyUsingLooker = (props: YouAreAlreadyUsingLookerProps) => {
  const {
    lookerIntegration: { base_url, database_connection_name },
    handleShowSnowflakeInLookerClick,
    databaseDisplayName,
  } = props;
  return (
    <div className="p-6 bg-[--sec-blue-50] text-pri-gray-500">
      <h2 className="text-lg font-medium">You have successfully connected Mozart Data to Looker.</h2>
      <p className="mt-2">
        Find Looker in the top navigation bar and via the button below. More integration features are
        coming soon!
      </p>
      {database_connection_name && (
        <p className="mt-2">
          Your{' '}
          <a
            // No dedicated page for the connection
            href={`${base_url}/admin/next/connections`}
            target="_blank"
            rel="noreferrer"
            className="text-purple"
          >
            Mozart Data {databaseDisplayName}
          </a>{' '}
          is connected to Looker.
        </p>
      )}
      <a href={base_url} target="_blank" rel="noreferrer">
        <IconButton
          icon="ChevronRight"
          text="GO TO LOOKER"
          iconLast={true}
          variant="lightDullTransparent"
          size="small"
          className="mt-2"
          noClickGuard
        />
      </a>
      {!database_connection_name && (
        <div>
          <p className="mt-4">
            If you have not yet connected Looker to your Mozart Data {databaseDisplayName}, you can do so
            below.
          </p>
          <Button
            size="large"
            className="mt-4"
            variant="darkDullAction"
            onClick={handleShowSnowflakeInLookerClick}
          >
            Connect Looker to {databaseDisplayName}
          </Button>
        </div>
      )}
    </div>
  );
};

export default YouAreAlreadyUsingLooker;
